import { addTracking as y } from "@sunrise/tracking";
import { defineComponent as m, getCurrentInstance as h, computed as a } from "vue";
import S from "./index12.js";
const p = m({
  name: "CsSecondaryButton",
  components: {
    CsButtonLoadingSpinner: S
  },
  props: {
    isDisabled: {
      type: Boolean,
      defaultValue: !1
    },
    isSmall: {
      type: Boolean,
      defaultValue: !1
    },
    target: {
      default: "_self",
      type: String
    },
    href: {
      default: "",
      type: String
    },
    rel: {
      default: void 0,
      type: String
    },
    ariaLabel: String,
    type: {
      default: "button",
      type: String
    },
    isCentered: {
      default: !1,
      type: Boolean
    },
    hasWhiteBackground: {
      default: !1,
      type: Boolean
    },
    isLoading: Boolean,
    trackingData: Array
  },
  setup(t) {
    var i;
    const e = (i = h()) == null ? void 0 : i.proxy, l = a(() => !!t.href), f = a(() => {
      var n;
      return l.value && ((n = t.href) == null ? void 0 : n.length) > 0 ? t.href : null;
    }), r = a(() => {
      var n;
      return l.value && t.rel && ((n = t.rel) == null ? void 0 : n.length) > 0 ? t.rel : null;
    }), u = a(() => l.value ? t.target : void 0), g = a(() => l.value ? null : t.type), s = a(() => l.value ? "a" : "button"), d = () => !!(e != null && e.$slots.default), c = () => !!(e != null && e.$slots.icon);
    let o;
    return t.trackingData && (o = y(t.trackingData)), {
      getHref: f,
      getRel: r,
      getTag: s,
      getTarget: u,
      getType: g,
      hasDefaultSlot: d,
      hasIconSlot: c,
      tracking: o
    };
  }
});
export {
  p as default
};
